export const FETCH_HOME_WIDGET_PENDING = 'FETCH_HOME_WIDGET_PENDING';
export const FETCH_HOME_WIDGET_REJECTED = 'FETCH_HOME_WIDGET_REJECTED';
export const FETCH_HOME_WIDGET_FULFILLED = 'FETCH_HOME_WIDGET_FULFILLED';



// WEBPACK FOOTER //
// ./src/constants/homeWidget.js